import axios from 'axios';
import { config } from '../config';

const API_URL = config.BACKEND_URL;

const api = axios.create({
  baseURL: API_URL,
  withCredentials: true
});

export const userService = {
  getUsers: () => api.get('/api/users'),
  createUser: (userData) => api.post('/api/users', userData),
  updateUserRole: (userId, role) => api.put(`/api/users/${userId}/role`, { role }),
  getGroups: () => api.get('/api/users/groups'),
  addGroup: (groupData) => api.post('/api/users/groups', groupData),
  removeGroup: (groupId) => api.delete(`/api/users/groups/${groupId}`),

  // Whitelist management
  getWhitelistedEmails: () => api.get('/api/users/whitelist'),
  addWhitelistedEmail: (emailData) => api.post('/api/users/whitelist', emailData),
  removeWhitelistedEmail: (email) => api.delete(`/api/users/whitelist/${encodeURIComponent(email)}`),
  updateUserWhitelist: (userId, isWhitelisted) => api.put(`/api/users/${userId}/whitelist`, { is_whitelisted: isWhitelisted })
};